import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, OnDestroy, ViewChild } from '@angular/core';

@Component({
    selector: 'popup-component',
    standalone: true,
    imports: [CommonModule],
    styleUrls: ['./PopupComponent.css'],
    templateUrl: './PopupComponent.html'
})
export class PopupComponent implements OnDestroy
{
    @ViewChild('popupRoot', { static: true }) popupRoot!: ElementRef<HTMLDivElement>;

    Visible: boolean = false;

    private originalParent?: Node;
    private placeholder?: Comment;

    Show(event?: MouseEvent): void
    {
        event?.stopPropagation();

        if (!this.Visible)
        {
            this.attachToBody();
        }

        this.Visible = true;
        const popup = this.popupRoot.nativeElement;
        let right: string;
        let top: string;
        if (event)
        {
            const button = event.currentTarget as HTMLElement;
            const buttonRect = button.getBoundingClientRect();
            right = (window.innerWidth - buttonRect.right - 2) + 'px';
            top = (buttonRect.bottom) + 'px';
        }
        else
        {
            right = '10px';
            top = '10px';
        }
        popup.style.right = right;
        popup.style.top = top;
        popup.classList.add('active');
    }

    Hide(event?: MouseEvent): void
    {
        event?.stopPropagation();
        this.Visible = false;
        const popup = this.popupRoot.nativeElement;
        popup.classList.remove('active');
        this.detachFromBody();
    }

    Toggle(event?: MouseEvent): void
    {
        event?.stopPropagation();
        if (this.Visible)
        {
            this.Hide();
        }
        else
        {
            this.Show(event);
        }
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent)
    {
        const popupEl = this.popupRoot.nativeElement;

        // If popup is visible and click is outside of it → hide
        if (this.Visible && !popupEl.contains(event.target as Node))
        {
            this.Hide();
        }
    }

    private attachToBody()
    {
        if (this.placeholder) return;

        const popup = this.popupRoot.nativeElement;
        this.originalParent = popup.parentNode!;
        this.placeholder = document.createComment('popup-placeholder');
        this.originalParent.insertBefore(this.placeholder, popup);

        document.body.appendChild(popup);
    }

    private detachFromBody()
    {
        if (!this.originalParent || !this.placeholder) return;

        const popup = this.popupRoot.nativeElement;
        this.originalParent.insertBefore(popup, this.placeholder);
        this.placeholder.remove();
        this.placeholder = undefined;
    }

    ngOnDestroy()
    {
        console.log('PopupComponent ngOnDestroy');
        this.detachFromBody();
    }
}
